import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';
import { SerialNumber } from '../interfaces/serialNumber';

export const serialNumbersService = {
  findSerial: (sn: string): Promise<SerialNumber> =>
    axiosService
      .get(`${AXIOS_URLS.serial_numbers}/${sn}`)
      .then((res) => res.data),
  update: (data: SerialNumber): Promise<SerialNumber> =>
    axiosService
      .patch(`${AXIOS_URLS.serial_numbers}/update`, data)
      .then((res) => res.data),
};
